import { render, staticRenderFns } from "./AddMemberNew.vue?vue&type=template&id=79b48857"
import script from "./AddMemberNew.vue?vue&type=script&lang=js"
export * from "./AddMemberNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports